export enum QuizQuestionType {
  PRE_QUIZ = 'Pre-Quiz',
  POST_QUIZ = 'Post-Quiz',
}
export interface IQuizQuestionProp {
  online_class_id: number;
  subject_id: number;
  quiz_type: QuizQuestionType; // pre quiz | post quiz
  onHide?: () => void;
}
export enum QUIZ_TYPE_STATUS {
  INACTIVE = 0,
  PRE_ACTIVE = 1,
  PRE_ENDED = 2,
  POST_ACTIVE = 3,
  POST_ENDED = 4,
}
export enum CLASS_TYPE {
  UNDEFINED = 'UNDEFINED',
  BIG_CLASS = 'ONLINE_CLASS_TYPE_BIG',
  SMALL_CLASS = 'ONLINE_CLASS_TYPE_SMALL',
  ROCKETEER = 'ONLINE_CLASS_TYPE_ROCKETEER',
  PSLE = 'ONLINE_CLASS_TYPE_PSLE',
  WEBINAR = 'ONLINE_CLASS_TYPE_WEBINAR',
  CAMPUS = 'ONLINE_CLASS_TYPE_CAMPUS',
}

// C2S
export enum GENERATE_WS_MODE {
  UNABLE_GENERATE_WS = '0',
  GENERATE_BY_TOPIC = '1',
  GENERATE_BY_SUBTOPIC = '2',
}
export enum GENERATE_C2S_WS_STATUS {
  SYSTEM_ERROR_CODE = 0,
  SUCCESS_CODE = 1,
  NOT_ENOUGH_QUESTION_CODE = 2,
}

export interface IStreamPageProp {
  subject_id: number;
  online_class_id: number;
}
export interface LessonTopicProps {
  id: number;
  name: string;
}
export interface LessonKnowledgeProps {
  id: number;
  name: string;
  topic_id?: number;
}

interface classToSmart {
  c2s_time_limit: string;
  c2s_worksheet_id: number;
  generate_ws: boolean;
  generate_status: boolean;
  generate_ws_mode: GENERATE_WS_MODE;
  subject_ids: number[];
  lesson_plan_topics: LessonTopicProps[] | null;
  lesson_plan_knowledges: LessonKnowledgeProps[] | null;
}
interface OnlineLessonAttendance {
  total_bubble_student: number;
  total_bubble: number;
  total_question: number;
  total_correct_answer: number;
  total_attempted: number;
  is_attend: boolean;
}

export interface OnlineLessonDetail {
  online_class_id: number;
  meeting_room_id: string;
  topic: string;
  date_time: string;
  duration: number;
  level_id: number;
  class_type: CLASS_TYPE;
  description: string;
  thumbnail: string;
  c2s_details?: classToSmart;
  url_recording: string;
  created_at: string;
  updated_at: string;
  has_quiz: boolean;
  quiz_status: QUIZ_TYPE_STATUS;
  subject_ids: number[];
  eligible: boolean;
  stream_engine: string;
  watch_percentage: number;
  last_watched_second: number;
  attendance: OnlineLessonAttendance;
  stream_url?: string;
}

export interface IGetCheckQuizTimeResponse {
  started: boolean;
  closed: boolean;
  finished: boolean;
  attempted: boolean;
}
